import Mixin from '../Mixin';
import FDictionaryTransport from '@/modules/Dictionary/Transport/Select';
import FDictionaryExcursion from '@/modules/Dictionary/Excursion/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  excursion = new FDictionaryExcursion({
    label: 'Экскурсия',
    required: true,
  });

  transport = new FDictionaryTransport({
    label: 'Транспорт',
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['excursion', this.excursion],
      ['transport', this.transport],
    ]);
    this.excursion.country = this.country;
    this.excursion.city = this.city;
    this.service.set({
      value: 4,
      label: 'Экскурсия',
    });
  }


  set(value = {}) {
    super.set(value);
    this.__set('excursion', value.excursion, null);
    this.__set('transport', value.transport, null);
    return this;
  }

  toString() {
    return this.excursion.toString();
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = this.excursion.toLabel();
        return data;
      });
  }
}
